// extracted by mini-css-extract-plugin
export default {"community_guidelines_container":"CommunityGuidelines_community_guidelines_container__XyD0c","community_guidelines_header":"CommunityGuidelines_community_guidelines_header__FUv35"};